'use strict';

const authentication = require('./authentication');
const profile = require('./profile');
const password = require('./password');
const registration = require('./registration');
const generateAuthToken = require('./generate-auth-token');
const sendVerificationEmail = require('./send-verification-email');
const getProductBoardToken = require('./product-board-token');
const getZendeskToken = require('./zendesk-token');
const verifyConfirmationToken = require('./verify-confirmation-token');
const difm = require('./difm');

module.exports = {
  generateAuthToken,
  sendVerificationEmail,
  verifyConfirmationToken,
  getProductBoardToken,
  getZendeskToken,
  declineDifm: difm.decline,
  remindLaterOfDifm: difm.remindLater,
  submitDifm: difm.submit,
  acceptDifmRequest: difm.acceptDifmRequest,
  getProfile: profile.getProfile,
  login: authentication.login,
  logout: authentication.logout,
  register: registration.register,
  passwordResetTokens: password.passwordResetTokens,
  resetPassword: password.resetPassword,
  changePassword: password.changePassword,
};
